import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";
import { BlockedIcon } from "src/lib/ui-icon-v2";

export function StatusCell<RowModel extends GridValidRowModel>({
  row,
  colDef,
}: GridRenderCellParams<RowModel>) {
  const theme = useNonConflictingTheme();

  return row[colDef.field] === "inactive" ? (
    <i
      className="icon-15-clear_x"
      css={{ color: theme.colorsV2.orange[500] }}
    />
  ) : row[colDef.field] === "blocked" ? (
    <BlockedIcon css={{ color: theme.colorsV2.red[500] }} />
  ) : (
    <i className="icon-15-chk_mrk" css={{ color: theme.colorsV2.green[500] }} />
  );
}
